import { addToast as toast } from "./store/toast-store";

export default toast;
